'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('../../extends-f8003900.js');
var React = require('react');
var index = require('../../index-0e40e0c2.js');
var components_NuDSProvider_NuDSProvider = require('../NuDSProvider/NuDSProvider.js');
var styles_breakpoints = require('../../breakpoints-7bb24b2d.js');
var styles_theme = require('../../theme-340a6118.js');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-02f83f64.js');
var slicedToArray = require('../../slicedToArray-e6d9072a.js');
var utils_isType_isType = require('../../utils/isType/isType.js');
require('../GlobalStyle/GlobalStyle.js');
require('styled-components');
require('../../unsupportedIterableToArray-a6f9513d.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../colorBuilder-0e3465cf.js');
require('../../polished.esm-0312677e.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof_1 = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof_1 = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var _typeof_1 = _typeof;

var _typeof$1 = _typeof_1;

var breakpoints = styles_theme.nuDSTheme.breakpoints;
var breakpointsNames = Object.keys(breakpoints).reverse();
var pixelDensities = ['1x', '2x', '3x'];

function createSource() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var pixelDensity = arguments.length > 1 ? arguments[1] : undefined;

  if (pixelDensity) {
    return {
      path: path,
      pixelDensity: pixelDensity
    };
  }

  return {
    path: path
  };
}

function createBreakPointWithSources(providedSourceForBreakpoint, breakPointValue) {
  return {
    breakPointValue: breakPointValue,
    sources: pixelDensities.reduce(function (acc, pixelDensity) {
      var pixelDensitySource = providedSourceForBreakpoint[pixelDensity];
      if (!pixelDensitySource) return acc;
      return [].concat(styles_breakpoints.toConsumableArray(acc), [createSource(pixelDensitySource, pixelDensity)]);
    }, [])
  };
}

function createBreakPointWithSource(providedSourceForBreakpoint, breakPointValue) {
  var source = createSource(providedSourceForBreakpoint);
  return {
    breakPointValue: breakPointValue,
    source: source
  };
}

function getSmallerSourcePathFrom(sourcesToRenderByBreakpoint) {
  var _sourcesToRenderByBre, _sourcesToRenderByBre2, _sourcesToRenderByBre3;

  var smallerSourceIndex = sourcesToRenderByBreakpoint.length - 1;
  var smallerImageFromSource = (_sourcesToRenderByBre = sourcesToRenderByBreakpoint[smallerSourceIndex]) === null || _sourcesToRenderByBre === void 0 ? void 0 : _sourcesToRenderByBre.source;
  var smallerImageFromSources = ((_sourcesToRenderByBre2 = sourcesToRenderByBreakpoint[smallerSourceIndex]) === null || _sourcesToRenderByBre2 === void 0 ? void 0 : _sourcesToRenderByBre2.sources) && ((_sourcesToRenderByBre3 = sourcesToRenderByBreakpoint[smallerSourceIndex]) === null || _sourcesToRenderByBre3 === void 0 ? void 0 : _sourcesToRenderByBre3.sources[0]);
  return (smallerImageFromSource === null || smallerImageFromSource === void 0 ? void 0 : smallerImageFromSource.path) || (smallerImageFromSources === null || smallerImageFromSources === void 0 ? void 0 : smallerImageFromSources.path);
}
function prepareSourcesToRender() {
  var srcSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    xl: '',
    lg: '',
    md: '',
    sm: '',
    xs: ''
  };
  return breakpointsNames.reduce(function (accSources, breakpointName) {
    var providedSourceForBreakpoint = srcSet[breakpointName];
    var hasProvidedSourceForBreakpoint = Boolean(providedSourceForBreakpoint);
    var breakPointValue = breakpoints[breakpointName];
    if (!hasProvidedSourceForBreakpoint) return accSources;
    var hasMultiSourcesForCurrentBreakpoint = _typeof$1(providedSourceForBreakpoint) === 'object';

    if (hasMultiSourcesForCurrentBreakpoint) {
      return [].concat(styles_breakpoints.toConsumableArray(accSources), [createBreakPointWithSources(providedSourceForBreakpoint, breakPointValue)]);
    }

    return [].concat(styles_breakpoints.toConsumableArray(accSources), [createBreakPointWithSource(providedSourceForBreakpoint, breakPointValue)]);
  }, []);
}

var avaiableTypes = new Set(['webp']);
function imageSourceResolver(imageSource) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    type: '',
    requireImage: components_NuDSProvider_NuDSProvider.requireImageFunctionDefault
  },
      type = _ref.type,
      requireImage = _ref.requireImage;

  var hasType = Boolean(type);
  var isValidType = avaiableTypes.has(type);

  if (hasType) {
    if (!isValidType) {
      throw new Error('You must proivde a valid type');
    }

    return requireImage(imageSource, type);
  }

  return requireImage(imageSource);
}

var _templateObject$1;
var width = xstyledStyledComponents_es.style({
  prop: 'width'
});
var height = xstyledStyledComponents_es.style({
  prop: 'height'
});
var maxWidth = xstyledStyledComponents_es.style({
  prop: 'maxWidth'
});
var objectFit = xstyledStyledComponents_es.style({
  prop: 'objectFit'
});
var objectPosition = xstyledStyledComponents_es.style({
  prop: 'objectPosition'
});
var styleProps = xstyledStyledComponents_es.compose(width, height, maxWidth, objectFit, objectPosition);
var SystemImage = xstyledStyledComponents_es.createSystemComponent(React__default['default'], 'img', styleProps);
var ImageWrapper = xstyledStyledComponents_es.styled(SystemImage)(_templateObject$1 || (_templateObject$1 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  display: block;\n  ", "\n"])), styleProps);
ImageWrapper.displayName = 'ImageWrapper';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var handleBackground = function handleBackground(imagePath) {
  var _useContext = React.useContext(components_NuDSProvider_NuDSProvider.NuDsContext),
      requireImageFunction = _useContext.requireImageFunction;

  var isImagePathNone = imagePath === 'none';

  if (isImagePathNone) {
    return xstyledStyledComponents_es.css(_templateObject || (_templateObject = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      background-image: none;\n    "])));
  }

  return xstyledStyledComponents_es.css(_templateObject2 || (_templateObject2 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n    background-image: url('", "');\n  "])), requireImageFunction(imagePath));
};

function createDPR(dpr) {
  return {
    pixelRatio: dpr,
    dpi: 96 * dpr,
    ddpx: dpr
  };
}

var DPRValuesByDensity = {
  '1x': createDPR(1),
  '2x': createDPR(2),
  '3x': createDPR(2.5)
};

function handlePixelRatioBreakpoints(srcSetDPR) {
  var has1xImage = srcSetDPR['1x'];

  if (!has1xImage) {
    throw new Error('You must provide the "1x" image to be used as default');
  }

  var breakpointDPRs = Object.entries(srcSetDPR);
  return xstyledStyledComponents_es.css(_templateObject3 || (_templateObject3 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n    ", "\n  "])), breakpointDPRs.map(function (_ref) {
    var _ref2 = slicedToArray.slicedToArray(_ref, 2),
        currentDPR = _ref2[0],
        currentImagePath = _ref2[1];

    var currentDensityDPRValues = DPRValuesByDensity[currentDPR];

    if (currentDPR === '1x') {
      return xstyledStyledComponents_es.css(_templateObject4 || (_templateObject4 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n        ", "\n      "])), handleBackground(currentImagePath));
    }

    return xstyledStyledComponents_es.css(_templateObject5 || (_templateObject5 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n      @media\n      only screen and (-webkit-min-device-pixel-ratio: ", "),\n      only screen and (        min-device-pixel-ratio: ", "),\n      only screen and (                min-resolution: ", "dpi),\n      only screen and (                min-resolution: ", "dppx) {\n        ", "\n      }\n    "])), currentDensityDPRValues.pixelRatio, currentDensityDPRValues.pixelRatio, currentDensityDPRValues.dpi, currentDensityDPRValues.ddpx, handleBackground(currentImagePath));
  }));
}

function handleBackgroundWithDPR(srcSetItem) {
  var isPixelRatioBreakpointPath = !utils_isType_isType.isType('string', srcSetItem);
  return isPixelRatioBreakpointPath ? handlePixelRatioBreakpoints(srcSetItem) : handleBackground(srcSetItem);
}

var backgroundImage = function backgroundImage(srcSet) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return function () {
    var _useContext2 = React.useContext(components_NuDSProvider_NuDSProvider.NuDsContext),
        backgroundImageFunction = _useContext2.backgroundImageFunction;

    var hasBackgroundImageFunction = Boolean(backgroundImageFunction);

    if (hasBackgroundImageFunction) {
      return backgroundImageFunction.apply(void 0, [srcSet].concat(args));
    }

    if (utils_isType_isType.isType('string', srcSet)) {
      return handleBackground(srcSet);
    }

    return styles_breakpoints.breakpointsMedia(Object.fromEntries(Object.entries(srcSet).map(function (_ref3) {
      var _ref4 = slicedToArray.slicedToArray(_ref3, 2),
          key = _ref4[0],
          set = _ref4[1];

      return [key, xstyledStyledComponents_es.css(_templateObject6 || (_templateObject6 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n        ", "\n      "])), handleBackgroundWithDPR(set))];
    })));
  };
};

function srcSetReducerFor(imageType, requireImageFn) {
  return function (acc, source, index, arr) {
    var isLastItem = arr.length - 1 === index;
    return "".concat(acc).concat(imageSourceResolver(source.path, {
      type: imageType,
      requireImage: requireImageFn
    }), " ").concat(source.pixelDensity).concat(!isLastItem ? ',' : '');
  };
}

function Image(_ref) {
  var alt = _ref.alt,
      altIntlKey = _ref.altIntlKey,
      className = _ref.className,
      loading = _ref.loading,
      importance = _ref.importance,
      src = _ref.src,
      srcSet = _ref.srcSet,
      webp = _ref.webp,
      title = _ref.title,
      titleIntlKey = _ref.titleIntlKey,
      type = _ref.type,
      width = _ref.width,
      height = _ref.height,
      maxWidth = _ref.maxWidth,
      objectFit = _ref.objectFit,
      objectPosition = _ref.objectPosition;

  var _useContext = React.useContext(components_NuDSProvider_NuDSProvider.NuDsContext),
      formatMessage = _useContext.formatMessage,
      requireImageFunction = _useContext.requireImageFunction;

  var altValue = alt || formatMessage({
    id: altIntlKey
  });
  var hasTitle = title || titleIntlKey;
  var titleValue = hasTitle ? title || formatMessage({
    id: titleIntlKey
  }) : null;
  var sourcesToRenderByBreakpoint = prepareSourcesToRender(srcSet);
  var baseFileSourcePath = src || getSmallerSourcePathFrom(sourcesToRenderByBreakpoint);
  var hasType = Boolean(type);
  var isWebpType = webp || type === 'webp';
  var isTypeEnabled = isWebpType || hasType;
  var imageType = isWebpType ? 'webp' : type;
  var imageTypeAttr = isTypeEnabled && {
    type: "image/".concat(imageType)
  };
  return /*#__PURE__*/React__default['default'].createElement("picture", null, sourcesToRenderByBreakpoint.map(function (_ref2) {
    var breakPointValue = _ref2.breakPointValue,
        source = _ref2.source,
        sources = _ref2.sources;
    return /*#__PURE__*/React__default['default'].createElement(React.Fragment, {
      key: breakPointValue
    }, isTypeEnabled && /*#__PURE__*/React__default['default'].createElement("source", _extends._extends({
      media: "(min-width:".concat(breakPointValue, "px)")
    }, imageTypeAttr, {
      srcSet: source ? imageSourceResolver(source.path, {
        type: imageType,
        requireImage: requireImageFunction
      }) : sources.reduce(srcSetReducerFor(imageType, requireImageFunction), '')
    })), /*#__PURE__*/React__default['default'].createElement("source", {
      media: "(min-width:".concat(breakPointValue, "px)"),
      srcSet: source ? imageSourceResolver(source.path, {
        type: '',
        requireImage: requireImageFunction
      }) : sources.reduce(srcSetReducerFor('', requireImageFunction), '')
    }));
  }), isTypeEnabled && /*#__PURE__*/React__default['default'].createElement("source", _extends._extends({}, imageTypeAttr, {
    srcSet: imageSourceResolver(baseFileSourcePath, {
      imageType: imageType,
      requireImage: requireImageFunction
    })
  })), /*#__PURE__*/React__default['default'].createElement(ImageWrapper, {
    src: imageSourceResolver(baseFileSourcePath, {
      requireImage: requireImageFunction
    }),
    alt: altValue,
    className: className,
    loading: loading,
    importance: importance,
    title: titleValue,
    width: width,
    height: height,
    maxWidth: maxWidth,
    objectFit: objectFit,
    objectPosition: objectPosition
  }));
}

Image.defaultProps = {
  alt: '',
  altIntlKey: '',
  className: '',
  loading: 'auto',
  importance: 'auto',
  webp: false,
  srcSet: {},
  src: '',
  title: '',
  titleIntlKey: '',
  type: '',
  width: '100%',
  height: 'auto',
  maxWidth: '100%',
  objectFit: undefined,
  objectPosition: ''
};
var DPRPropTypes = index.PropTypes.shape({
  '1x': index.PropTypes.string.isRequired,
  '2x': index.PropTypes.string,
  '3x': index.PropTypes.string
});
var imageShape = {
  alt: index.PropTypes.string,
  altIntlKey: index.PropTypes.string,
  className: index.PropTypes.string,
  height: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  importance: index.PropTypes.oneOf(['high', 'low', 'auto']),
  loading: index.PropTypes.oneOf(['lazy', 'eager', 'auto']),
  maxWidth: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object]),
  objectFit: index.PropTypes.oneOfType([index.PropTypes.oneOf(['fill', 'contain', 'cover', 'none', 'scale-down']), index.PropTypes.object]),
  objectPosition: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.object]),
  srcSet: index.PropTypes.shape({
    /* eslint-disable react/sort-prop-types */
    xl: index.PropTypes.oneOfType([index.PropTypes.string, DPRPropTypes]),
    lg: index.PropTypes.oneOfType([index.PropTypes.string, DPRPropTypes]),
    md: index.PropTypes.oneOfType([index.PropTypes.string, DPRPropTypes]),
    sm: index.PropTypes.oneOfType([index.PropTypes.string, DPRPropTypes]),
    xs: index.PropTypes.oneOfType([index.PropTypes.string, DPRPropTypes])
    /* eslint-disable react/sort-prop-types */

  }),
  src: index.PropTypes.string,
  title: index.PropTypes.string,
  titleIntlKey: index.PropTypes.string,
  type: index.PropTypes.string,
  webp: index.PropTypes.bool,
  width: index.PropTypes.oneOfType([index.PropTypes.string, index.PropTypes.number, index.PropTypes.object])
};
Image.propTypes = imageShape;
var Image$1 = /*#__PURE__*/React__default['default'].memo(Image);

exports.backgroundImage = backgroundImage;
exports.default = Image$1;
exports.imageShape = imageShape;
//# sourceMappingURL=Image.js.map
